export const RaikoChipTypes = {
    error: "raikoErrorChip",
    success: "raikoSuccessChip",
    warning: "raikoWarningChip",
    info: "raikoInfoChip",
    primary: "raikoPrimaryChip"
}